





















import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { InfoFile } from '@/modules/infodayco/shared/domain/info-file';

@Component({
    name: 'info-file-box',
})
export default class InfoFileBox extends Vue {
    @Prop({ required: true })
    private file!: InfoFile;

    @Prop({ required: true })
    private downloadFileFunction!: Function;

    @Prop({ required: true })
    private deleteFileFunction!: Function;

    private isLoading: boolean = false;

    async openFile() {
        this.isLoading = true;
        await this.downloadFileFunction(this.file);
        this.isLoading = false;
    }

    async deleteFile() {
        await this.deleteFileFunction(this.file);
    }
}
